import { jsxs as w, jsx as k } from "react/jsx-runtime";
import { c as h } from "react/compiler-runtime";
import { useEffect as u, useRef as b } from "react";
import { M as P } from "../../../chunks/index.esm.js";
import { renderToString as x } from "react-dom/server";
function G(t) {
  if (!t) return null;
  const e = typeof t.lat == "function" ? t.lat() : t.lat, r = typeof t.lng == "function" ? t.lng() : t.lng;
  return e == null || r == null ? null : {
    lat: e,
    lng: r
  };
}
const d = {
  cbrs: "#C600CA",
  public: "#00A8CA",
  radio: "#226a58"
}, T = Object.keys(d);
function C(t) {
  const e = String(t ?? "");
  return e.startsWith("cbrs") ? "cbrs" : e.startsWith("public") ? "public" : "radio";
}
function S(t) {
  const e = {
    cbrs: [],
    public: [],
    radio: []
  };
  for (const r of t) {
    const o = C(r.markerId);
    e[o].push(r);
  }
  return e;
}
function v(t) {
  return {
    render(e) {
      const r = document.createElement("div");
      return r.style.cssText = `
        width: 50px;
        height: 50px;
        background-color: ${t};
        border: 3px solid white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 12px;
        font-family: Arial, sans-serif;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      `, r.textContent = String(e.count), new google.maps.marker.AdvancedMarkerElement({
        position: e.position,
        content: r,
        gmpClickable: !0,
        zIndex: 1e3 + e.count
      });
    }
  };
}
function M(t) {
  t && t.setMap(null);
}
function I(t, e) {
  const r = {}, o = (n) => {
    const i = S(n);
    for (const s of T) {
      const c = i[s], a = r[s];
      if (c.length === 0) {
        M(a), delete r[s];
        continue;
      }
      if (!a) {
        r[s] = new P({
          map: t,
          markers: c,
          renderer: v(d[s])
        });
        continue;
      }
      a.clearMarkers(!0), a.addMarkers(c);
    }
  };
  return o(e), {
    /**
     * Removes all markers and disposes all clusterers for every type.
     */
    clearMarkers: () => {
      for (const n of Object.keys(r))
        M(r[n]), delete r[n];
    },
    /**
     * Updates/synchronizes the marker set, regrouping clusters as necessary.
     * @param next New set of markers to cluster.
     */
    addMarkers: o
  };
}
let L;
function O() {
  return L ??= new google.maps.Geocoder();
}
async function R(t, e) {
  return new Promise((r, o) => {
    O().geocode({
      location: {
        lat: t,
        lng: e
      }
    }, (n, i) => {
      if (i !== google.maps.GeocoderStatus.OK) {
        o("Geocoder failed due to: " + i);
        return;
      }
      if (!n?.[0]) {
        r("No results found");
        return;
      }
      r(n[0].formatted_address);
    });
  });
}
function N(t, e) {
  const r = x(/* @__PURE__ */ w("div", { style: {
    color: "white",
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    marginTop: 10,
    padding: 10,
    maxWidth: 180
  }, children: [
    /* @__PURE__ */ k("img", { src: e.icon, alt: e.name, width: 18, height: 18 }),
    /* @__PURE__ */ k("span", { children: e.name })
  ] }));
  new google.maps.InfoWindow({
    content: r,
    position: e.geometry?.location,
    ariaLabel: e.name
  }).open(t), e.geometry?.viewport && (t.fitBounds(e.geometry.viewport), e.geometry.location && t.setCenter(e.geometry.location));
}
async function $(t, e, r, o) {
  if (!(!t || !e) && (e.position = t.getCenter(), o)) {
    const n = t.getCenter().toJSON(), i = await R(n.lat, n.lng), s = {
      id: r ?? "Custom",
      location: {
        lat: n.lat,
        lng: n.lng,
        address: i
      },
      label: e.title ?? "",
      metadata: {
        resetToMapCenter: !0
      }
    };
    o(s);
  }
}
function D(t, e, r, o) {
  const n = h(8);
  let i;
  n[0] !== r || n[1] !== e || n[2] !== o || n[3] !== t ? (i = () => {
    if (!e)
      return;
    let c;
    t && (c = new google.maps.Marker({
      position: r,
      map: e,
      draggable: !0,
      icon: {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new google.maps.Size(20, 30),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 30)
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1
    }), c.addListener("dragend", () => {
      const l = c?.getPosition()?.toJSON();
      l && o(l);
    }));
    const a = google.maps.event.addListener(e, "dragend", () => {
      const l = e.getCenter();
      c?.setPosition(l), l && o(l.toJSON());
    });
    return () => {
      c?.setMap(null), google.maps.event.removeListener(a);
    };
  }, n[0] = r, n[1] = e, n[2] = o, n[3] = t, n[4] = i) : i = n[4];
  let s;
  n[5] !== e || n[6] !== t ? (s = [e, t], n[5] = e, n[6] = t, n[7] = s) : s = n[7], u(i, s);
}
function H(t, e, r) {
  const o = b(void 0);
  return u(() => {
    if (e) {
      if (!t) {
        o.current?.clearMarkers(), o.current = void 0;
        for (const n of r)
          n.map || (n.map = e);
        return;
      }
      return o.current?.clearMarkers(), o.current = I(e, r), () => {
        o.current?.clearMarkers(), o.current = void 0;
      };
    }
  }, [t, e, r]), o;
}
function J(t, e) {
  const r = h(4);
  let o, n;
  r[0] !== e || r[1] !== t ? (o = () => {
    if (t) {
      for (const i of e)
        t.controls[google.maps.ControlPosition.TOP_RIGHT].push(i);
      return () => {
        t.controls[google.maps.ControlPosition.TOP_RIGHT].clear();
      };
    }
  }, n = [t, e], r[0] = e, r[1] = t, r[2] = o, r[3] = n) : (o = r[2], n = r[3]), u(o, n);
}
const U = v(d.radio), X = (t) => {
  const e = document.createElement("div"), r = x(t);
  e.innerHTML = r;
  const o = e.querySelector("svg");
  if (!o) return "";
  const n = new XMLSerializer().serializeToString(o);
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(n)}`;
}, q = (t, e, r) => {
  const o = t.position, n = r.getProjection();
  if (!o || !n) return [];
  const i = Math.pow(2, r.getZoom() || 0), s = n.fromLatLngToPoint(o), c = 30, a = t.markerId;
  return e.filter((l) => {
    const g = l.position;
    if (!g) return !1;
    const f = l.markerId;
    if (a && f && f === a)
      return !1;
    const p = n.fromLatLngToPoint(g), m = (s.x - p.x) * i, y = (s.y - p.y) * i;
    return Math.sqrt(m * m + y * y) < c;
  });
};
export {
  U as AdvancedMarkerCustomRenderer,
  d as CLUSTER_TYPE_COLORS,
  X as convertSvgToUrl,
  v as createClusterRenderer,
  q as findOverlappingMarkers,
  R as generateAddress,
  G as getLatLng,
  C as getMarkerIdType,
  S as groupMarkersByIdType,
  $ as resetMarkerToCenter,
  N as updateMapWithPlace,
  D as useCenterMarker,
  J as useMapControls,
  H as useMarkerCluster
};
